import 'lazysizes';

function getImage(imageUrl, imageHolder) {
  let newImage = document.createElement('img');
  newImage.src = imageUrl;
  newImage.onload = function () {
    imageHolder.style.backgroundImage = "url('" + newImage.src + "')";
    imageHolder.setAttribute('data-bg', newImage.src);
  };
}

export function resizeBackgroundImages(responsiveImages, event) {
  for (var i = 0; i < responsiveImages.length; i++) {
    const responsiveImage = responsiveImages[i];
    const windowWidth = window.innerWidth;
    const sizes = responsiveImage.getAttribute('data-sizes').split(',');
    const largeImage = responsiveImage.getAttribute('data-large_image');
    let imageLoaded = responsiveImage.getAttribute('data-loaded');
    let flag = false;

    if (responsiveImage.classList.contains('lazyloaded')) {
      for (let i = 0; i < sizes.length; i++) {
        const size = sizes[i];
        const image = size.split('@@@')[0];
        const mediaQuery = size.split('@@@')[1];
        const lastMediaQuery = sizes[sizes.length - 1].split('@@@')[1];

        if (event === 'resize' && (windowWidth >= lastMediaQuery || windowWidth <= mediaQuery)) {
          imageLoaded = 'false';
        }

        if (!flag) {
          if (windowWidth <= mediaQuery && imageLoaded == 'false') {
            getImage(image, responsiveImage);
            responsiveImage.setAttribute('data-loaded', true);
            flag = true;
          } else if (windowWidth >= lastMediaQuery && imageLoaded == 'false') {
            responsiveImage.setAttribute('data-loaded', true);
            getImage(largeImage, responsiveImage);
          }
        }
      }
    }
  }
}

function initResponsiveImages() {
  const eventsToListen = ['load', 'resize', 'scroll'];

  eventsToListen.forEach(function (event) {
    window.addEventListener(event, function () {
      const targetImages = document.querySelectorAll('.js-responsive-background-image');
      resizeBackgroundImages(targetImages, event);
    });
  });
}

initResponsiveImages();
